/* eslint-disable import/no-cycle */
import { lazy } from 'react';

const Portfolio = lazy(() => import(/* webpackChunkName: "portfolio" */ './Portfolio'));
const SectionAutoInvest = lazy(() =>
  import(/* webpackChunkName: "portfolio-auto" */ './SectionAutoInvest')
);
const SectionMutualFund = lazy(() =>
  import(/* webpackChunkName: "portfolio-mf" */ './SectionMutualFund')
);
const SectionRightIssue = lazy(() =>
  import(/* webpackChunkName: "portfolio-ri" */ './SectionRightIssue')
);
const SectionStock = lazy(() => import(/* webpackChunkName: "portfolio-stock" */ './SectionStock'));
const SectionMarginTrading = lazy(() =>
  import(/* webpackChunkName: "portfolio-mt" */ './SectionMarginTrading')
);
const SectionDayTrading = lazy(() =>
  import(/* webpackChunkName: "portfolio-dt" */ './SectionDayTrading')
);

export {
  Portfolio,
  SectionAutoInvest,
  SectionMutualFund,
  SectionRightIssue,
  SectionStock,
  SectionMarginTrading,
  SectionDayTrading,
};
